import React, { useEffect, useState, useReducer, useContext, useRef } from "react";
import { useLocation, useHistory } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";
import { IconRefresh } from "../../../svg";
import { CardAtividadesOptions } from "../../../components/CardAtividadesOptions";
import { StyledForm } from "../../../styled-components/StyledForm.style";
import { ToggleSwitchFilters } from "../../../components/ToggleSwitchFilters";
import { DynamicInput } from "../../../components/DynamicInput";
import { DynamicSelect } from "../../../components/DynamicSelect";
import { StldRow } from "../../../styled-components/StldRow.style";
import { StldColumn } from "../../../styled-components/StldColumn.style";
import { useForm } from 'react-hook-form';
import { PaginationCustom } from "../../../components/PaginationCustom";
import api from '../../../services/api';
import { Multiselect } from 'multiselect-react-dropdown';
import { MobileContext } from "../../../contexts/MobileContext";
import { ModalProjetoInterno } from "../../../components/ModalProjetoInterno";
import { ModalObservacao } from "../../../components/ModalObservacao";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { getSinisterStatus, getSinisterPort, getSinisterTypes } from '../../../services/sinistro';
import { getStatusList } from '../../../services/status';
import { getAtividades } from '../../../services/atividades';
import { getClients } from '../../../services/clientes';
import { getWorkflow } from '../../../services/workflow';
import { getPeritos } from '../../../services/peritos';
import { getDisciplinas } from '../../../services/disciplinas';
import { getCheckAllTS } from '../../../services/check-visibilidade-listas';
import { getExportarTimesheet } from '../../../services/check-visibilidade-listas';
import { ModalEsclarecimento } from "../../../components/ModalEsclarecimento";
import { ModalTimelinePI } from "../../../components/ModalTimelinePI";
import * as moment from 'moment'
import DatePicker from 'react-datepicker';
import InputMask from "react-input-mask";
import { TableTimesheetPI } from "../../../components/TableTimesheetPI";
import logo from "../../../assets/criterio-experts.png";
import logoExcel from "../../../assets/criterio-experts-excel.png";

const ExcelJS = require('exceljs');

let controllerTS;
const requestGetListaTimeSheet = async (params) => {
    if (controllerTS) {
        controllerTS.abort();
    }

    controllerTS = new AbortController();
    const signal = controllerTS.signal;

    let list = null;
    try {
        const response = await api.get(`Timesheet/list?${params}&ProjetoInterno=true`, { signal });
        list = response.data;
        return list;
    } catch (err) {
        return list;
    }
}



const useQuery = () => {
    return new URLSearchParams(useLocation().search);
}

const getQueryParams = (query) => {
    const params = {};
    for (let [key, value] of query.entries()) {
        if (params[key]) {
            params[key] = [].concat(params[key], value);
        } else {
            params[key] = value;
        }
    }
    return params;
}


export const TimeSheetPI = () => {

    const [showAdvanceSearch, setAdvanceSearch] = useState(false);
    var [showTableView, setShowTableView] = useState(false);
    var [legendaTableView, setLegendaTableView] = useState("Tabelas");
    const [defaultSetted, setDefaultSetted] = useState(null);
    const [TimeSheetData, setTimeSheetData] = useState(null);
    const [filtersCount, setFiltersCount] = useState([]);
    const [filterCountsSub, setFilterCountsSub] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const { register, handleSubmit, reset, setValue } = useForm();
    const [disciplinaList, setDisciplinaList] = useState([]);
    const [disciplinaDefaultValue, setDisciplinaDefaultValue] = useState([]);
    const [peritosList, setPeritosList] = useState([]);
    const [peritosListDefaultValue, setPeritosListDefaultValue] = useState([]);
    const [workflowList, setWorkflowList] = useState([]);
    const [workflowListDefault, setWorkflowListDefault] = useState([]);
    const [clientList, setClientList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [integradoList, setIntegradoList] = useState([]);
    const [sinisterType, setSinisterType] = useState([]);
    const [atividades, setAtividades] = useState([]);
    const [sinisterPort, setSinisterPort] = useState([]);
    const [sinisterStatus, setSinisterStatus] = useState([]);

    var [startDate, setStartDate] = useState(null);
    var [endDate, setEndtDate] = useState(null);
    var [loadingData, setLoadingData] = useState(true);
    var [pageSize, setPageSize] = useState(300);
    var [meusTimesheets, setMeusTimeSheets] = useState(false);
    var [checkAllTSPermission, setCheckAllTSPermission] = useState(false);
    var [checkExportarPermission, setCheckExportarPermission] = useState(false);
    var [reguladora, setReguladora] = useState(null);
    var [idReguladora, setIdReguladora] = useState(null);
    var [integrado, setIntegrado] = useState(null);
    var [idIntegrado, setIdIntegrado] = useState(null);
    var [idCorretora, setIdCorretora] = useState(null);
    var [disciplina, setDisciplina] = useState(null);
    var [perito, setPerito] = useState(null);
    var [idDisciplinas, setDisciplinasId] = useState([]);
    var [idPeritos, setPeritosId] = useState([]);
    var [idStatus, setStatusId] = useState([]);
    var [idStatusList, setStatusIdList] = useState([]);
    var [isNotificados, setIsNotificados] = useState(false);
    var [isEsclarecimento, setIsEsclarecimento] = useState(false);
    var [isReprovados, setIsReprovados] = useState(false);
    var [idWorkflow, setWorkflowId] = useState([]);
    var [cliente, setCliente] = useState(null);
    var [idCliente, setIdCliente] = useState(null);
    var [idEmpresa, setIdEmpresa] = useState(1);
    var [idEmpresaIndexTab, setIdEmpresaIndexTab] = useState(0);
    var [porteSinistro, setPorteSinistro] = useState(null);
    var [idPorteSinistro, setIdPorteSinistro] = useState(null);
    var [status, setStatus] = useState(null);
    var [tipoSinistro, setTipoSinistro] = useState(null);
    var [atividade, setAtividade] = useState(null);
    var [idTipoSinistro, setIdTipoSinistro] = useState(null);
    var [workflow, setWorkflow] = useState(null);
    var [idAtividade, setIdAtividade] = useState(null);
    var [searchReadOnly, setSearchReadOnly] = useState(false);
    var [searchInput, setSearchInput] = useState(null);
    var [empresasUser, setEmpresasUser] = useState([]);
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;
    const multiselectRef = useRef();
    const [modalIsOpen, setIsOpen] = useState(false);
    const [modalObservacoes, setmodalObservacoes] = useState(false);
    const [selectedTimesheet, setSelectedTimesheet] = useState(null);
    const [selectedIdTimesheet, setSelectedIdTimesheet] = useState(null);
    const [modalEsclarecimento, setmodalEsclarecimento] = useState(false);
    const [modalTimelineIsOpen, setmodalTimelineIsOpen] = useState(false);

    const history = useHistory();
    const query = useQuery();
    const queryParams = getQueryParams(query);

    const advanceSearch = { name: 'advanceSeach', label: 'Pesquisa Avançada', id: 'advanceSeachTS', status: showAdvanceSearch, checked: showAdvanceSearch };
    const advanceTimesheet = { name: 'advanceTimesheet', label: 'Todos Timesheets', id: 'advanceTimesheetTS', status: meusTimesheets, checked: meusTimesheets };
    const advanceShowTableView = { name: 'showTableView', label: legendaTableView, id: 'idshowTableView', status: showTableView, checked: showTableView };

    const getListaTimeSheet = async (formValues = null, currentPage = 0, pageSize) => {

        let params = `Start=${currentPage}&Length=${pageSize ?? 300}`;

        params += `&meuTimeSheet=${!formValues?.meusTimesheets}`;
        params += `&IdEmpresa=${formValues.idEmpresa}`;

        if (formValues?.search && formValues?.search?.length > 0) {
            params += `&Search=${formValues.search}`;
        }

        if (formValues?.data?.NumeroTimesheet?.length > 0) {
            params += `&NumeroTimesheet=${formValues.data.NumeroTimesheet}`;
        }

        if (formValues?.data?.Sigla?.length > 0) {
            params += `&PericiaSigla=${formValues.data.Sigla}`;
        }

        if (formValues?.data?.EnderecoSinistro?.length > 0) {
            params += `&Endereco=${formValues.data.EnderecoSinistro}`;
        }

        if (formValues?.idDisciplinas?.length > 0) {
            formValues?.idDisciplinas.forEach(disciplina => {
                params += `&Disciplinas=${disciplina}`;
            });
        }

        if (formValues?.idPeritos?.length > 0) {
            formValues?.idPeritos.forEach(idPerito => {
                params += `&Peritos=${idPerito}`;
            });
        }

        if (formValues?.idWorkflow?.length > 0) {
            formValues?.idWorkflow.forEach(step => {
                params += `&Steps=${step}`;
            });
        }

        if (formValues?.idCliente && formValues?.idCliente > 0) {
            params += `&IdCliente=${formValues.idCliente}`;
        }

        if (formValues?.idAtividade > 0) {
            params += `&IdAtividade=${formValues.idAtividade}`;
        }

        if (formValues?.idIntegrado > 0) {
            params += `&Integrado=${formValues.idIntegrado === 1 ? true : false}`;
        }

        if (formValues?.idCorretora > 0) {
            params += `&IdCorretora=${formValues.idCorretora}`;
        }

        if (formValues?.idTipoSinistro > 0) {
            params += `&IdTipoSinistro=${formValues.idTipoSinistro}`;
        }

        if (formValues?.idPorteSinistro > 0) {
            params += `&IdPorteSinistro=${formValues.idPorteSinistro}`;
        }

        if (formValues?.idStatus > 0) {
            params += `&Status=${formValues.idStatus}`;
        }


        if (formValues?.idStatusList?.length > 0) {
            formValues?.idStatusList.forEach(itemStatus => {
                params += `&Status=${itemStatus}`;
            });
        }

        if (moment(formValues?.startDate).isValid()) {
            params += `&PeriodoInicial=${moment(formValues.startDate).format('YYYY-MM-DD')}`;
        }

        if (moment(formValues?.endDate).isValid()) {
            params += `&PeriodoFinal=${moment(formValues.endDate).format('YYYY-MM-DD')}`;
        }

        if (formValues.notificado) {
            params += `&PeriodoFinal=${moment(formValues.endDate).format('YYYY-MM-DD')}`;
        }

        if (formValues.isNotificados) {
            params += `&Notificados=true`;
        }

        if (formValues.isReprovados) {
            params += `&Reprovados=true`;
        }

        if (formValues.isEsclarecimento) {
            params += `&Esclarecimento=true`;
        }


        history.replace(`timesheet-pi?${params}&showAdvanceSearch=${showAdvanceSearch}`)

        setLoadingData(true);

        const rstData = await requestGetListaTimeSheet(params);;

        setLoadingData(false);

        return rstData;
    }

    const formSubmit = async (data, meusTimesheetsParam = false) => {
        formData(data, 0, 300, meusTimesheetsParam);
    }

    const formData = async (data, currentPage, pageSize, meusTimesheetsParam = false) => {
        let formValues = {
            meusTimesheets: meusTimesheets,
            data: data,
            search: searchInput?.length >= 3 ? searchInput : null,
            idDisciplinas: idDisciplinas,
            idPeritos: idPeritos,
            idCliente: idCliente,
            idEmpresa: idEmpresa,
            idAtividade: idAtividade,
            idReguladora: idReguladora,
            idCorretora: idCorretora,
            idTipoSinistro: idTipoSinistro,
            idPorteSinistro: idPorteSinistro,
            idWorkflow: idWorkflow,
            idIntegrado: idIntegrado,
            idStatus: idStatus,
            startDate: startDate,
            endDate: endDate,
            isNotificados: isNotificados,
            isReprovados: isReprovados,
            isEsclarecimento: isEsclarecimento,
            idStatusList: idStatusList,
        };

        setTimeSheetData(null);

        try {
            const TimeSheet = await getListaTimeSheet(formValues, currentPage, pageSize);

            if (TimeSheet?.data && TimeSheet?.data?.itens?.length > 0) {
                setTimeSheetData(TimeSheet);
            }
            setFiltersCount(TimeSheet.data.page.filterCounts);
            setFilterCountsSub(TimeSheet.data.page.filterCountsSub);
        } catch (error) {
            console.log(error);
        } finally {}
    };

    const openObservacoesTimesheet = (idTimesheet) => {
        setSelectedIdTimesheet(idTimesheet)
        openModalObservacoesOpen()
    }

    const openModalASolicitarEsclarecimento = (timesheet) => {
        setSelectedIdTimesheet(timesheet.idTimesheet)
        setmodalEsclarecimento(true)
    }

    const getStatusToggle = (status) => {
        setAdvanceSearch(status);
        setSearchReadOnly(status);
        searchReadOnly = status;
    };

    const getTimesheetToggle = (status) => {
        setAdvanceSearch(status);
    };

    const openModalObservacoesOpen = () => {
        setmodalObservacoes(true);
    };

    const closeModalObservacoes = () => {
        setmodalObservacoes(false);
    }


    const afterNotifyGrupoOpenModal = () => { };

    const onGetDisciplina = (currentValue, value) => {
        let disciplinasList = [];

        disciplina = value.titulo;
        setDisciplina(disciplina);

        currentValue.map(a => { disciplinasList.push(a.idDisciplina) });
        idDisciplinas = disciplinasList;

        setDisciplinasId(disciplinasList);
    };

    const onGetPerito = (currentValue, value) => {
        let peritosList = [];

        perito = value.nome;
        setPerito(perito);

        currentValue.map(a => { peritosList.push(a.idUsuario) });
        idPeritos = peritosList;

        setPeritosId(peritosList);
    };

    const onGetWorkflow = (currentValue, value) => {

        let workflowListP = [];

        if (currentValue?.length > 0) {
            currentValue.map(a => {
                a.idsSteps.map(b => { workflowListP.push(b) });
            });

            idWorkflow = workflowListP;
            setWorkflowId(workflowListP);
        }
    };

    const onRemoveDisciplina = (currentValue, value) => {
        let disciplinasList = [];

        currentValue.map(a => { disciplinasList.push(a.idDisciplina) });
        idDisciplinas = disciplinasList;

        setDisciplinasId(disciplinasList);
    }

    const onRemovePerito = (currentValue, value) => {
        let peritosList = [];

        currentValue.map(a => { peritosList.push(a.idUsuario) });
        idPeritos = peritosList;

        setPeritosId(peritosList);
    }

    const onRemoveWorkflow = (currentValue, value) => {
        let workflowListP = [];

        if (currentValue?.length > 0) {
            currentValue.map(a => {
                a.idsSteps.map(b => { workflowListP.push(b) });
            });

            idWorkflow = workflowListP;
            setWorkflowId(workflowListP);
        }
    }
    const onRemoveEsclarecimento = (currentValue, value) => { }

    const getSearch = async (currentValue, value, pageSize = 300, forceidEmpresa = false) => {
        searchInput = (currentValue >= 3) ? currentValue : null;
        setSearchInput(currentValue);

        try {
            let data = {
                IdentificaoSolicitacao: null,
                Contato: null,
                Endereco: null
            }

            let formValues = {
                data: data,
                search: (currentValue?.length >= 3) ? currentValue : '',
                idDisciplinas: null,
                idCliente: null,
                idEmpresa: forceidEmpresa != false ? forceidEmpresa : idEmpresa,
                idReguladora: null,
                idCorretora: null,
                idTipoSinistro: null,
                idPorteSinistro: null,
                idWorkflow: null,
                idStatus: null,
                idStatusList: idStatusList,
                idIntegrado: null,
                startDate: null,
                endDate: null,
                meusTimesheets: meusTimesheets,
                isNotificados: isNotificados,
                isReprovados: isReprovados,
                isEsclarecimento: isEsclarecimento,
            };
            setPageSize(pageSize);

            const TimeSheet = await getListaTimeSheet(formValues, currentPage, pageSize);
            setTimeSheetData(null);


            if (TimeSheet?.data?.itens && TimeSheet?.data?.itens?.length > 0) {
                setTimeSheetData(TimeSheet);
                pageSize = TimeSheet.length;
            }
            setFiltersCount(TimeSheet.data.page.filterCounts);
            setFilterCountsSub(TimeSheet.data.page.filterCountsSub);
        } catch (e) {

        } finally {

        }
    };

    const refreshData = async (isNull = false) => {

        let data = {
            IdentificaoSolicitacao: null,
            Contato: null,
            Endereco: null
        }

        let formValues = {
            data: data,
            search: (searchInput?.length >= 3) ? searchInput : '',
            idDisciplinas: idDisciplinas,
            idCliente: idCliente,
            idEmpresa: idEmpresa,
            idReguladora: idReguladora,
            idCorretora: idCorretora,
            idTipoSinistro: idTipoSinistro,
            idPorteSinistro: idPorteSinistro,
            idWorkflow: idWorkflow,
            idStatus: idStatus,
            idIntegrado: idIntegrado,
            startDate: startDate,
            endDate: endDate,
            meusTimesheets: meusTimesheets
        };

        if (isNull) {
            for (const key in formValues) {
                if (Object.hasOwnProperty.call(formValues, key)) {
                    formValues[key] = null;

                }
            }
            formValues.meusTimesheets = meusTimesheets;
            formValues.idEmpresa = idEmpresa;
        }


        setPageSize(pageSize);

        setTimeSheetData(null);

        try {

            const TimeSheet = await getListaTimeSheet(formValues, currentPage, pageSize);

            if (TimeSheet.data.itens.length > 0) {
                setTimeSheetData(TimeSheet);
                pageSize = TimeSheet.length;
                setFiltersCount(TimeSheet.data.page.filterCounts);
                setFilterCountsSub(TimeSheet.data.page.filterCountsSub);
            }

            setTimeout(() => {
                //
            }, 1000);

        } catch (error) {
            console.log(error);
        }
    }

    const getMeusTimeshets = (status) => {
        meusTimesheets = status;
        setMeusTimeSheets(status);
        setTimeout(() => {
            formSubmit(null, status);
        }, 500);
    };


    const getShowTableView = (status) => {
        showTableView = status;
        setShowTableView(status);
        legendaTableView = !status ? 'Tabela' : 'Cards';
        setLegendaTableView(legendaTableView);
    };


    const getCliente = (currentValue, value) => {
        var clienteResult = clientList.filter(function (o) {
            return o.idCliente == value;
        });
        cliente = clienteResult[0].cliente;
        idCliente = clienteResult[0].idCliente;
        setCliente(cliente);
        setIdCliente(idCliente);
    };

    const getPorteSinistro = (currentValue, value) => {

        if (!value) {
            setPorteSinistro(null);
            setIdPorteSinistro(null);
            return;
        }


        var porteSinistroResult = sinisterPort.filter(function (o) {
            return o.key == value;
        });

        porteSinistro = porteSinistroResult[0].value;
        idPorteSinistro = porteSinistroResult[0].key;
        setPorteSinistro(porteSinistro);
        setIdPorteSinistro(idPorteSinistro);
    };

    const getTipoSinistro = (currentValue, value) => {
        if (!value) {
            setTipoSinistro(null);
            setIdTipoSinistro(null);
            return;
        }


        var tipoSinistroResult = sinisterType.filter(function (o) {
            return o.key == value;
        });
        tipoSinistro = tipoSinistroResult[0].value;
        idTipoSinistro = tipoSinistroResult[0].key;
        setTipoSinistro(tipoSinistro);
        setIdTipoSinistro(idTipoSinistro);
    };


    const getIntegrado = (currentValue, value) => {
        if (!value) {
            setIntegrado(null);
            setIdIntegrado(null);
            return;
        }


        var idIntegradoResult = integradoList.filter(function (o) {
            return o.key == value;
        });

        integrado = idIntegradoResult[0].value;
        idIntegrado = idIntegradoResult[0].key;
        setIntegrado(integrado);
        setIdIntegrado(idIntegrado);
    };

    const getAtividade = (currentValue, value) => {


        if (!value) {
            setAtividade(null);
            setIdAtividade(null);
            return;
        }

        var atividadeResult = atividades.filter(function (o) {
            return o.key == value;
        });

        atividade = atividadeResult[0].value;
        idAtividade = atividadeResult[0].key;
        setAtividade(atividade);
        setIdAtividade(idAtividade);
    };

    const getStatus = (currentValue, value) => {

        if (!value) {
            setStatus(null);
            setStatusId(null);
            return;
        }

        var statusResult = statusList.filter(function (o) {
            return o.key == value;
        });

        status = statusResult[0].value;
        idStatus = statusResult[0].key;
        setStatus(status);
        setStatusId(idStatus);
    };

    const getCardId = (id) => {
        let cardId = document.getElementById(id);
        if (cardId.getAttribute('class', 'card-menu-hide') === 'card-menu-hide') {
            cardId.removeAttribute('class', 'card-menu-hide');
            cardId.setAttribute('class', 'card-menu-show');
        }
        else {
            cardId.removeAttribute('class', 'card-menu-show');
            cardId.setAttribute('class', 'card-menu-hide');
        }
    };

    const submitButtonRef = useRef(null)


    const handleStartDateChange = (date) => {
        setStartDate(date);
    }


    const handleEndDateChange = (date) => {
        setEndtDate(date);
    }


    const openModal = () => {
        setIsOpen(true);
    };


    const addListStatus = (status) => {
        idStatusList.push(status);
        setStatusIdList(idStatusList);
    }
    const removeListStatus = (status) => {
        idStatusList = idStatusList.filter(item => item !== status);
        setStatusIdList(idStatusList);
    }

    // set Tipo notificado ou reprovado
    const setTipoNotOuRepFiltro = (event, id) => {

        if (id === 'Reprovado') {
            isReprovados = event.target.checked;
            setIsReprovados(isReprovados);
        }

        if (id === 'Notificado') {
            isNotificados = event.target.checked;
            setIsNotificados(isNotificados);
        }

        if (id === 'Esclarecimento') {
            isEsclarecimento = event.target.checked;
            setIsEsclarecimento(isEsclarecimento);
        }
    }

    const handleOnChangeFilter = (event, id, tipo = false) => {

        if (!tipo) {
            (event.target.checked) ? addListStatus(id) : removeListStatus(id);
        } else {
            setTipoNotOuRepFiltro(event, id)
        }

        getSearch(null, null, 300);
    }

    const resetFormAvancado = () => {


        history.replace(`timesheet-pi?timesheet?Start=0&Length=300&meuTimeSheet=true&showAdvanceSearch=true`);
        reset({
            IdentificaoSolicitacao: '',
            Contato: '',
            Endereco: ''
        });

        reguladora = null;
        idReguladora = null;
        setReguladora(null);
        setIdReguladora(null);

        tipoSinistro = null;
        idTipoSinistro = null;
        setTipoSinistro(null);
        setIdTipoSinistro(null);


        cliente = null;
        idCliente = null;
        setCliente(null);
        setIdCliente(null);

        status = null;
        idStatus = null;
        setStatus(null);
        setStatusId(null);

        porteSinistro = null;
        idPorteSinistro = null;
        setPorteSinistro(null);
        setIdPorteSinistro(null);

        integrado = null;
        idIntegrado = null;
        setIdIntegrado(null);
        setIntegrado(null);

        disciplina = null;
        idDisciplinas = null;
        setDisciplinasId(null);
        setDisciplinaDefaultValue(null);

        perito = null;
        idPeritos = null;
        setPeritosId(null);
        setPeritosListDefaultValue(null);

        workflow = null;
        idWorkflow = null;
        setWorkflowId(null);
        setWorkflowListDefault(null);

        setValue('NumeroTimesheet', '');
        setValue('Sigla', '');
        setValue('EnderecoSinistro', '');


        setAtividade(null);
        setIdAtividade(null);

        setStartDate(null);
        setEndtDate(null);

        setSearchInput(null);
        idStatusList = [];
        setStatusIdList([]);
        setIsNotificados(false);
        setIsReprovados(false);
        setIsEsclarecimento(false);

        multiselectRef.current.resetSelectedValues();


        formData({
            IdentificaoSolicitacao: null,
            Contato: null,
            Endereco: null
        }, 0, 300);
    }


    const openModalTimesheetTimeline = (timesheet) => {
        setSelectedTimesheet(timesheet)
        setmodalTimelineIsOpen(true)
    }

    useEffect(() => {
        Promise.all([
            getDisciplinas(),
            getPeritos(),
            getWorkflow(),
            getClients(),
            getSinisterPort(21),
            getSinisterTypes(20),
            getSinisterStatus(2),
            getAtividades(40),
            getStatusList(10),
            getCheckAllTS(),
            getExportarTimesheet()
        ]).then((dataResponse) => {
            setDisciplinaList(dataResponse[0]);
            setPeritosList(dataResponse[1]);

            setClientList(dataResponse[3]);
            setSinisterPort(dataResponse[4]);
            setSinisterType(dataResponse[5]);
            setSinisterStatus(dataResponse[6]);
            setAtividades(dataResponse[7]);
            setStatusList(dataResponse[8]);

            setIntegradoList([{ key: 1, value: "Sim" }, { key: 2, value: "Não" }]);

            setDefaultFiltersDisciplina(dataResponse[0], queryParams?.Disciplinas);
            setDefaultFiltersPerito(dataResponse[1], queryParams?.Peritos);
            setDefaultFiltersAtividade(dataResponse[7], queryParams?.IdAtividade);
            setDefaultFiltersStatus(dataResponse[6], queryParams?.Status);

            setDefaultFiltersCliente(dataResponse[3], queryParams?.IdCliente);
            checkIsMultEmpresaUser();
            setDefaultFiltersEmpresa(queryParams?.IdEmpresa);
            setDefaultFiltersPorte(dataResponse[4], queryParams?.IdPorteSinistro);
            setDefaultFiltersTipoSinistro(dataResponse[5], queryParams?.IdTipoSinistro);

            setDefaultFiltersIntegrado(integradoList, queryParams?.Integrado);
            queryParams.meuTimeSheet = dataResponse[9] ? 'false' : 'true';

            setCheckAllTSPermission(dataResponse[9]);
            setCheckExportarPermission(dataResponse[10]);

            const rstWorkflowList = agruparEmNovoAtributo(dataResponse[2], 'step', 'idsSteps');
            setWorkflowList(rstWorkflowList);
            setDefaultFiltersEtapaAp(rstWorkflowList, queryParams?.Steps);

            setDefaultFilters();
        });
    }, []);

    const checkIsMultEmpresaUser = (value) => {
        const empresas = localStorage.getItem('empresasUsuario') ?
            JSON.parse(localStorage.getItem('empresasUsuario'))
            : [];

        if (empresas) {
            empresasUser = empresas;
            setEmpresasUser(empresasUser);
        }

        if (empresasUser.length > 1) {
            setIdEmpresa(1);
            setIdEmpresaIndexTab(0);
        }
        else {
            setIdEmpresa(empresas[0]);
        }
    }

    const filtroEmpresa = (indexTab) => {
        setIdEmpresaIndexTab(indexTab)
        var empresa = 0
        switch (indexTab) {
            case 0:
                empresa = 1;
                break;
            case 1:
                empresa = 2;
                break;
            case 2:
                empresa = -1;
                break;
            default:
                empresa = -1;
                break;
        }

        setIdEmpresa(empresa);
        getSearch(searchInput, null, 300, empresa);
    }

    const agruparEmNovoAtributo = (lista, propriedade, novoAtributo) => {
        const agrupado = {};
        lista.forEach(item => {
            const chave = item[propriedade];

            if (!agrupado[chave]) {
                agrupado[chave] = {
                    ...item,
                    [novoAtributo]: []
                };
            }

            agrupado[chave][novoAtributo].push(item.idStep);
        });

        return Object.values(agrupado);
    }

    const setDefaultFiltersAtividade = (itensList, itenFiltered) => {

        if (itenFiltered && itensList.length > 0) {
            var atividadeResult = itensList.find((o) => o.key === parseInt(itenFiltered, 10));
            atividade = atividadeResult?.value ?? null;
            idAtividade = atividadeResult?.key ?? null;
            setAtividade(atividade);
            setIdAtividade(idAtividade);
        }
    }

    const setDefaultFiltersCliente = (itensList, itenFiltered) => {
        if (itenFiltered && itensList.length > 0) {

            var clienteResult = itensList.find((o) => o.idCliente === parseInt(itenFiltered, 10));
            cliente = clienteResult?.cliente ?? null;
            idCliente = clienteResult?.idCliente ?? null;
            setCliente(cliente);
            setIdCliente(idCliente);
        }
    }

    const setDefaultFiltersEmpresa = (itenFiltered) => {
        if (itenFiltered) {
            idEmpresa = itenFiltered;
            setIdEmpresa(idEmpresa);

            switch (itenFiltered) {
                case '0':
                case 0:
                    setIdEmpresaIndexTab(2);
                    break;
                case '1':
                case 1:
                    setIdEmpresaIndexTab(0);
                    break;
                case '2':
                case 2:
                    setIdEmpresaIndexTab(1);
                    break;
                default:
                    setIdEmpresaIndexTab(2);
                    break;

            }
        }
    }

    const setDefaultFiltersStatus = (itensList, itenFiltered) => {
        if (itenFiltered && itensList.length > 0) {

            var statusResult = itensList.find((o) => o.key === parseInt(itenFiltered, 10));
            status = statusResult?.value ?? null;
            idStatus = statusResult?.key ?? null;
            setStatus(status);
            setStatusId(idStatus);

        }
    }

    const setDefaultFiltersPorte = (itensList, itenFiltered) => {
        if (itenFiltered && itensList.length > 0) {

            var porteSinistroResult = itensList.find((o) => o.key === parseInt(itenFiltered, 10));

            porteSinistro = porteSinistroResult?.value ?? null;
            idPorteSinistro = porteSinistroResult?.key ?? null;
            setPorteSinistro(porteSinistro);
            setIdPorteSinistro(idPorteSinistro);

        }
    }

    const setDefaultFiltersTipoSinistro = (itensList, itenFiltered) => {

        if (itenFiltered && itensList.length > 0) {

            var tipoSinistroResult = itensList.find((o) => o.key === parseInt(itenFiltered, 10));

            tipoSinistro = tipoSinistroResult?.value ?? null;
            idTipoSinistro = tipoSinistroResult?.key ?? null;
            setTipoSinistro(tipoSinistro);
            setIdTipoSinistro(idTipoSinistro);

        }
    }


    const setDefaultFiltersIntegrado = (itensList, itenFiltered) => {

        if (!itenFiltered) {
            setIdIntegrado(null);
            setIntegrado(null);
            return;
        }
        setIdIntegrado(itenFiltered === 'true' ? 1 : 2);
        setIntegrado(itenFiltered === 'true' ? 'Sim' : 'Não');

    }

    const setDefaultFiltersDisciplina = (itensList, itenFiltered) => {
        if (itenFiltered && itensList.length > 0) {
            const ids = itenFiltered?.length > 0 && typeof itenFiltered != 'string' ? itenFiltered.map(item => parseInt(item, 10)) : [parseInt(itenFiltered, 10)];
            const disciplinasListParam = itensList.filter(item => ids.includes(item.idDisciplina));
            setDisciplinasId(ids);
            setDisciplinaDefaultValue(disciplinasListParam);

        }
    }

    const setDefaultFiltersPerito = (itensList, itenFiltered) => {
        if (itenFiltered && itensList.length > 0) {
            const ids = itenFiltered?.length > 0 && typeof itenFiltered != 'string' ? itenFiltered.map(item => parseInt(item, 10)) : [parseInt(itenFiltered, 10)];
            const peritosListParam = itensList.filter(item => ids.includes(item.idUsuario));
            setPeritosId(ids);
            setPeritosListDefaultValue(peritosListParam);
        }
    }


    const setDefaultFiltersEtapaAp = (itensList, itenFiltered) => {
        if (itenFiltered && itensList.length > 0) {
            const ids = itenFiltered?.length > 0 && typeof itenFiltered != 'string' ? itenFiltered : [itenFiltered];
            const workflowSelected = itensList.filter(item => ids.includes(item.idStep));
            setWorkflowId(ids);
            setWorkflowListDefault(workflowSelected);
        }
    }

    const setDefaultFilters = () => {
        let data = {
            NumeroTimesheet: (queryParams?.NumeroTimesheet?.length >= 3) ? queryParams.NumeroTimesheet : null,
            Sigla: (queryParams?.PericiaSigla?.length >= 3) ? queryParams.PericiaSigla : null,
            EnderecoSinistro: (queryParams?.Endereco?.length >= 3) ? queryParams.Endereco : null,
        }

        setValue('NumeroTimesheet', (queryParams?.NumeroTimesheet?.length >= 3) ? queryParams.NumeroTimesheet : null);
        setValue('Sigla', (queryParams?.PericiaSigla?.length >= 3) ? queryParams.PericiaSigla : null);
        setValue('EnderecoSinistro', (queryParams?.Endereco?.length >= 3) ? queryParams.Endereco : null);

        const chck = queryParams.meuTimeSheet === 'false' ? true : false;
        meusTimesheets = chck;
        setMeusTimeSheets(chck);

        setAdvanceSearch(queryParams?.showAdvanceSearch === 'true' ? true : false);
        
        var pesquisaInput = (queryParams?.Search?.length >= 3) ? queryParams?.Search : null;
        setSearchInput(pesquisaInput);

        setStartDate(formatToDate(queryParams?.PeriodoInicial));
        setEndtDate(formatToDate(queryParams?.PeriodoFinal));

        if (queryParams?.Status) {
            const ids = queryParams?.Status?.length > 0 && typeof queryParams?.Status != 'string' ? queryParams?.Status.map(item => parseInt(item, 10)) : [parseInt(queryParams?.Status, 10)];
            idStatusList = ids;
            setStatusIdList(idStatusList);
        }

        isNotificados = queryParams?.Notificados === 'true' ? true : false;
        setIsNotificados(isNotificados);

        isReprovados = queryParams?.Reprovados === 'true' ? true : false;
        setIsReprovados(isReprovados);

        isReprovados = queryParams?.Esclarecimento === 'true' ? true : false;
        setIsEsclarecimento(isReprovados);

        setDefaultSetted(data)
    }

    // Após setar todos os filtros é necessário usar o useeffect em uma variável diferente para que as alterçaões de state sejam refletidas
    useEffect(() => {
        if(defaultSetted)
            formData(defaultSetted, 0, 300);
    }, [defaultSetted])


    const formatToDate = (date) => {
        if (!date) {
            return null;
        }
        return moment(date).toDate();
    }


    const formatNumberValue = (value) => {

        if (null === value || undefined === value || '' === value) {
            return 0;
        }


        if (typeof value === 'number') {
            return value;
        }

        value = value.replace(/(\.)/g, '').replace('R$', '').replace(',', '.');
        if (isNaN(value)) {
            return 0;
        }

        value = parseFloat(value);

        return value;
    }

    /// EXPORT EXCEL
    const getParamsForExport = () => {
        const search = history.location.search || ''; // ex.: ?Start=0&Length=300&...
        const usp = new URLSearchParams(search);
        usp.delete('showAdvanceSearch');
        // URLSearchParams inclui o '?' no início? Não. Então retornamos só a query string.
        // Também garanta que Start/Length estejam presentes (se quiser forçar os defaults).
        if (!usp.has('Start')) usp.set('Start', currentPage ?? 0);
        if (!usp.has('Length')) usp.set('Length', pageSize ?? 300);
        return usp.toString();
    };

    let controllerTSExport;
        const requestGetListaTimeSheetExport = async (params) => {
        if (controllerTSExport) controllerTSExport.abort();
        controllerTSExport = new AbortController();
        const signal = controllerTSExport.signal;

        try {
            const resp = await api.get(`Timesheet/listExport?${params}&ProjetoInterno=true`, { signal });
            return resp.data;
        } catch (err) {
            return null;
        }
    };

    const exportExcel = async () => {

        const exportParams = getParamsForExport();
        const exportResp = await requestGetListaTimeSheetExport(exportParams);
        const rows = exportResp?.data?.itens ?? exportResp?.itens ?? TimeSheetData?.data?.itens ?? [];

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("serviços");
        const imageId2 = workbook.addImage({
            base64: logoExcel,
            extension: 'png',
        });        

        worksheet.addImage(imageId2, 'A1:B3');
        worksheet.autoFilter = 'A5:T5';
        worksheet.getRow(5).values = [
            "Laudo",
            "TS",
            "Tipo TS",
            "Horas",
            "Valor",
            "Vida Útil",
            "Disciplina",
            "Líder",
            "Status TS",
            "Seguradora",            
            "Etapa Aprovação",            
            "Data de Abertura",
            "Data Finalização TS",
            "Data Revisão Gestão",
            "Data Revisão Administrativo",
            "Data Revisão Diretoria",
            "Data Envio ao Cliente",
            "Data Aprovação Cliente",
            "Data Faturamento",
            "Data Recebimento"
        ];
        worksheet.columns = [
            { key: "Laudo", width: 15, style: { alignment: { vertical: 'middle', horizontal: 'left' } } },
            { key: "TS", width: 15, style: { alignment: { vertical: 'middle', horizontal: 'left' } } },
            { key: "Tipo TS", width: 30, style: { alignment: { vertical: 'middle', horizontal: 'left' } } },
            { key: "Horas", width: 15, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
            { key: "Valor", width: 15, style: { alignment: { vertical: 'middle', horizontal: 'right' } } },
            { key: "Vida Útil", width: 15, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
            { key: "Disciplina", width: 15, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
            { key: "Líder", width: 20, style: { alignment: { vertical: 'middle', horizontal: 'left' } } },
            { key: "Status TS", width: 30, style: { alignment: { vertical: 'middle', horizontal: 'left' } } },
            { key: "Seguradora", width: 30, style: { alignment: { vertical: 'middle', horizontal: 'left' } } },            
            { key: "Etapa Aprovação", width: 30, style: { alignment: { vertical: 'middle', horizontal: 'left' } } },
            { key: "Data de Abertura", width: 20, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
            { key: "Data Finalização TS", width: 20, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
            { key: "Data Revisão Gestão", width: 20, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
            { key: "Data Revisão Administrativo", width: 20, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
            { key: "Data Revisão Diretoria", width: 20, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
            { key: "Data Envio ao Cliente", width: 20, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
            { key: "Data Aprovação Cliente", width: 20, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
            { key: "Data Faturamento", width: 20, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
            { key: "Data Recebimento", width: 20, style: { alignment: { vertical: 'middle', horizontal: 'center' } } }
        ];

        worksheet.getRow(5).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "EE4B21" },
        };

        worksheet.getRow(5).font = {
            color: { rgb: "FFFFFF" },
            family: 4,
            size: 12,
            bold: true,
        };

        worksheet.getRow(5).eachCell((cell) => {
            cell.border = {
                top: { style: "thin", color: { rgb: "FFFFFF" } },
                left: { style: "thin", color: { rgb: "FFFFFF" } },
                bottom: { style: "thin", color: { rgb: "FFFFFF" } },
                right: { style: "thin", color: { rgb: "FFFFFF" } },
            };

            cell.font = {
                color: { argb: "FFFFFF" },
                family: 4,
                size: 12,
                bold: true,
            };

            cell.alignment = {
                vertical: 'middle', 
                horizontal: 'center'
            }
        });

        rows.map(timesheetEX => {
            const row = worksheet.addRow({
                "Laudo": timesheetEX.sigla,
                "TS": timesheetEX.timeSheetSigla,
                "Tipo TS": timesheetEX.tipoTimesheet,
                "Horas": formatNumberValue(timesheetEX.horasTimeSheet),
                "Valor": formatNumberValue(timesheetEX.valorTimesheet),
                "Vida Útil": formatNumberValue(timesheetEX.vidaUtil),
                "Disciplina": timesheetEX.disciplina,  
                "Líder": timesheetEX.lider,
                "Status TS": timesheetEX.statusTimesheet,
                "Seguradora": timesheetEX.cliente.clienteNome,
                "Etapa Aprovação": timesheetEX.workflow,                              
                "Data de Abertura": isValidDate(timesheetEX.datasEtapas.dataAbertura) ? formatDate(timesheetEX.datasEtapas.dataAbertura) : null,
                "Data Finalização TS": isValidDate(timesheetEX.datasEtapas.dataFinalizacaoTS) ? formatDate(timesheetEX.datasEtapas.dataFinalizacaoTS) : null,
                "Data Revisão Gestão": isValidDate(timesheetEX.datasEtapas.dataRevisaoGestao) ? formatDate(timesheetEX.datasEtapas.dataRevisaoGestao) : null,
                "Data Revisão Administrativo": isValidDate(timesheetEX.datasEtapas.dataRevisaoAdministrativo) ? formatDate(timesheetEX.datasEtapas.dataRevisaoAdministrativo) : null,
                "Data Revisão Diretoria": isValidDate(timesheetEX.datasEtapas.dataRevisaoDiretoria) ? formatDate(timesheetEX.datasEtapas.dataRevisaoDiretoria) : null,                
                "Data Envio ao Cliente": isValidDate(timesheetEX.datasEtapas.dataEnvioCliente) ? formatDate(timesheetEX.datasEtapas.dataEnvioCliente) : null,
                "Data Aprovação Cliente": isValidDate(timesheetEX.datasEtapas.dataAprovacaoCliente) ? formatDate(timesheetEX.datasEtapas.dataAprovacaoCliente) : null,
                "Data Faturamento": isValidDate(timesheetEX.datasEtapas.dataFaturamento) ? formatDate(timesheetEX.datasEtapas.dataFaturamento) : null,
                "Data Recebimento": isValidDate(timesheetEX.datasEtapas.dataRecebimento) ? formatDate(timesheetEX.datasEtapas.dataRecebimento) : null,
            });

            row.eachCell({ includeEmpty: true }, (cell) => {
                cell.border = {
                    top: { style: "thin", color: { rgb: "000000" } },
                    left: { style: "thin", color: { rgb: "000000" } },
                    bottom: { style: "thin", color: { rgb: "000000" } },
                    right: { style: "thin", color: { rgb: "000000" } },
                };
            });
        })


        const dataExport = moment().format('DD-MM-YYYY');
        worksheet.mergeCells('A1:T4');
        worksheet.getColumn(4).numFmt = '0.00';
        worksheet.getColumn(5).numFmt = '[$R$-1] #,##0.00;[Red][$R$-1]-#,##0.00';
        worksheet.getColumn(6).numFmt = '0';

        worksheet.getColumn(12).numFmt = 'dd/mm/yyyy';
        worksheet.getColumn(13).numFmt = 'dd/mm/yyyy';
        worksheet.getColumn(14).numFmt = 'dd/mm/yyyy';
        worksheet.getColumn(15).numFmt = 'dd/mm/yyyy';
        worksheet.getColumn(16).numFmt = 'dd/mm/yyyy';
        worksheet.getColumn(17).numFmt = 'dd/mm/yyyy';
        worksheet.getColumn(18).numFmt = 'dd/mm/yyyy';
        worksheet.getColumn(19).numFmt = 'dd/mm/yyyy';
        worksheet.getColumn(20).numFmt = 'dd/mm/yyyy';

        workbook.xlsx.writeBuffer().then(function (data) {
            const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.href = url;
            anchor.download = `TS_todos-${dataExport}.xlsx`;
            anchor.click();
            window.URL.revokeObjectURL(url);
        });
    }

    const formatDate = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return new Date(`${year}-${month}-${day}`);
    }
    
    const isValidDate = (d) => {
       const date = new Date(d);
       return d && !isNaN(date);
    };

    /// EXPORT EXCEL


    return (
        <section>
            <main className="d-flex">
                {(() => {
                    if (isDesktop) {
                        return (
                            <Menu></Menu>
                        )
                    }
                    return null
                })()}
                <StyledDefaultPage>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h5 className="title-row-header m-0">Timesheet - PI</h5>
                            <span title="Atualizar" className="cursorPointer" onClick={refreshData}><IconRefresh color={"#EE4B21"} /></span>
                        </div>
                        <div className="">
                            {
                                TimeSheetData?.data?.itens?.length > 0 && checkExportarPermission && (<input type="button" className='default-button-red mr-1' value='Exportar' onClick={exportExcel} />)
                            }
                            <input className='default-button-red ' value='Adicionar' type="button" onClick={openModal} />
                        </div>
                    </div>
                    <div className="card">

                        <div className="row">
                            <div className="form-container d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-2">
                                <ToggleSwitchFilters config={advanceTimesheet} setStatus={(status) => getMeusTimeshets(status)} />
                                {isDesktop ? <span style={{ marginTop: '2px' }}><ToggleSwitchFilters config={advanceShowTableView} setStatus={(status) => getShowTableView(status)} /></span> : null}
                            </div>
                            <div className="col-sm-12 col-md-3 col-lg-3 col-xxl-3 my-1-mobile">
                                <DynamicInput type={'text'} placeholder={''} componentReadOnly={searchReadOnly} label={'Pesquisar'} name={'Search'} paramMethod={getSearch} value={searchInput} />
                            </div>
                            <div className="d-flex flex-column justify-content-center col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3 ">
                                <ToggleSwitchFilters config={advanceSearch} setStatus={(status) => getStatusToggle(status)} />
                            </div>
                            <div className="pull-right col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                                <div id="legendaGrupoDetalheTs" key={'legendaGrupoDetalheTs'} className="row">
                                    <div id="legendaCardDetalheTs" key={'legendaCardDetalheTs'} className="btn-group btn-group-sm" role="group">
                                        {
                                            filterCountsSub?.map((item, index) => {
                                                return (
                                                    <>
                                                        <input type="checkbox" name="filterSubCheckStatus"
                                                            className="btn-check d-flex" key={'filterSubCheckBox' + item.key}
                                                            id={'filterSubCheckBox' + item.key}
                                                            value={item.key} onChange={(event) => handleOnChangeFilter(event, item.label, true)}
                                                            checked={(item.label === 'Notificado' && isNotificados) || (item.label === 'Reprovado' && isReprovados) || (item.label === 'Esclarecimento' && isEsclarecimento)}
                                                        />
                                                        <label className="btn btn-sm btn-light mb-0 w-100 py-0" style={{ padding: ".05rem .05rem" }} key={'filterCheckBoxLabel' + item.key} htmlFor={'filterSubCheckBox' + item.key}> <span className="text-max-10">{item.label}</span>
                                                            <br /><span className={'badge bg-primary color-text-filter  filter-' + item.label} key={'filterSubCheckBoxLabelCount' + item.key} >{item.count}</span>
                                                        </label >

                                                    </>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <StyledForm onSubmit={handleSubmit(formSubmit)}>
                            <div className={!!showAdvanceSearch ? `form-wrapper filter-container mt-4` : `form-wrapper filter-container filter-hide`}>
                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Nº Timesheet'} name={'NumeroTimesheet'} register={register} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Sigla'} name={'Sigla'} register={register} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2">
                                    <DynamicSelect placeholder={''} valuetext={cliente} label={'Selecione o cliente'} name={'idCliente'} options={clientList} keyValue={'idCliente'} keyLabel={'cliente'} clearOption={true} paramMethod={getCliente} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'End Sinistro'} name={'EnderecoSinistro'} register={register} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2 header-select">
                                    <Multiselect
                                        className="searchWrapperCustom"
                                        placeholder={'Selecione a disciplina'}
                                        showCheckbox="true"
                                        options={disciplinaList} // Options to display in the dropdown
                                        selectedValues={disciplinaDefaultValue} // Preselected value to persist in dropdown
                                        onSelect={onGetDisciplina} // Function will trigger on select event
                                        onRemove={onRemoveDisciplina} // Function will trigger on remove event
                                        displayValue="titulo" // Property name to display in the dropdown options
                                        ref={multiselectRef}
                                        showArrow={true}
                                    />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2">
                                    <Multiselect
                                        className="searchWrapperCustom"
                                        placeholder={'Profissionais'}
                                        showCheckbox="true"
                                        options={peritosList} // Options to display in the dropdown
                                        selectedValues={peritosListDefaultValue} // Preselected value to persist in dropdown
                                        onSelect={onGetPerito} // Function will trigger on select event
                                        onRemove={onRemovePerito} // Function will trigger on remove event
                                        displayValue="nome" // Property name to display in the dropdown options
                                        ref={multiselectRef}
                                        showArrow={true}
                                    />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-sm-12 col-md-6 col-lg-6 p-2">
                                    <DynamicSelect placeholder={''} valuetext={atividade} label={'Atividade'} name={'idAtividade'} options={atividades} keyValue={'key'} keyLabel={'value'} clearOption={true} paramMethod={getAtividade} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-sm-12 col-md-6 col-lg-6 p-2">
                                    <DynamicSelect placeholder={''} valuetext={status} label={'Status'} name={'Status'} options={statusList} keyValue={'key'} keyLabel={'value'} clearOption={true} paramMethod={getStatus} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2">
                                    <Multiselect
                                        className="searchWrapperCustom"
                                        placeholder={'Etapa Aprovação'}
                                        showCheckbox="true"
                                        options={workflowList} // Options to display in the dropdown
                                        selectedValues={workflowListDefault} // Preselected value to persist in dropdown
                                        onSelect={onGetWorkflow} // Function will trigger on select event
                                        onRemove={onRemoveWorkflow} // Function will trigger on remove event
                                        displayValue="step" // Property name to display in the dropdown options
                                        ref={multiselectRef}
                                        showArrow={true}
                                    />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2">
                                    <DynamicSelect placeholder={''} valuetext={integrado} label={'Integrado'} name={'idIntegrado'} options={integradoList} keyValue={'key'} keyLabel={'value'} clearOption={true} paramMethod={getIntegrado} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2">
                                    <DynamicSelect placeholder={''} valuetext={tipoSinistro} label={'Tipo Sinistro'} name={'idTipoSinistro'} options={sinisterType} keyValue={'key'} keyLabel={'value'} clearOption={true} paramMethod={getTipoSinistro} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2">
                                    <DynamicSelect placeholder={''} valuetext={porteSinistro} label={'Porte Sinistro'} name={'idPorteSinistro'} options={sinisterPort} keyValue={'key'} keyLabel={'value'} clearOption={true} paramMethod={getPorteSinistro} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3" style={{ float: 'left' }}>
                                    <DatePicker
                                        dateFormat="dd/MM/yyyy"
                                        locale="pt-BR"
                                        className="input-form"
                                        selected={startDate}
                                        onChange={handleStartDateChange}
                                        placeholderText={'Data de início'}
                                        customInput={<InputMask mask="99/99/9999" className="input-form py-2" style={{ width: '100%' }} />}
                                    />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3" style={{ float: 'left' }}>
                                    <DatePicker
                                        dateFormat="dd/MM/yyyy"
                                        locale="pt-BR"
                                        className="input-form"
                                        selected={endDate}
                                        onChange={handleEndDateChange}
                                        placeholderText={'Data fim'}
                                        customInput={<InputMask mask="99/99/9999" className="input-form py-2" style={{ width: '100%' }} />}
                                    />
                                </div>
                                <div className="position-relative form-group col-sm-3 col-md-3 col-lg-3 p-2">
                                    <input type="submit" className='default-button-red' value='Pesquisar' ref={submitButtonRef} />
                                </div>
                                <div className="position-relative form-group col-sm-3 col-md-3 col-lg-3 p-2">
                                    <input className='default-button' value='Limpar' type="button" onClick={resetFormAvancado} />
                                </div>

                            </div>
                        </StyledForm>

                        <div className="row d-none d-sm-block mt-1" key={'filterCheckStatusList'}>
                            <div className="btn-group btn-group-sm" role="group" key={'filterCheckStatusListGroup'}>
                                {

                                    filtersCount?.map((item, index) => {

                                        return (
                                            <>
                                                <input type="checkbox" name="filterCheckStatus" className="btn-check d-flex"
                                                    key={'CheckBox' + item.key} id={'CheckBox' + item.key} value={item.key}
                                                    onChange={(event) => handleOnChangeFilter(event, item.key)}
                                                    checked={idStatusList?.includes(item.key)}
                                                />
                                                <label className="btn btn-sm btn-light mb-0 w-100" key={'CheckBoxLabel' + item.key}
                                                    htmlFor={'CheckBox' + item.key}> <span className="text-max-10">{item.label}</span>
                                                    <br /><span className="badge bg-primary" key={'CheckBoxLabelCount' + item.key} >{item.count}</span>
                                                </label >

                                            </>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <Tabs className="timesheet" selectedIndex={idEmpresaIndexTab} onSelect={(index) => filtroEmpresa(index)} focusTabOnClick={false}>
                            <div className={'row justify-content-between'} key={'filterTabsListRow'}>
                                <div className="col-xs-6 col-sm-8 col-md-4 col-lg-5 col-xl-5 " >
                                    {empresasUser?.length > 1 ?
                                        <TabList>
                                            <Tab>Critério Experts</Tab>
                                            <Tab>Adjusters</Tab>
                                            <Tab>Todos</Tab>
                                        </TabList> : ''}
                                </div>
                            </div>
                            <TabPanel>
                                {loadingData ? <StldRow>
                                    <div className="text-center">
                                        <div className="d-flex align-items-center">
                                            <strong style={{ color: "#EE4B21" }}>Atualizando...</strong>
                                            <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                        </div>
                                    </div>
                                </StldRow> : ''}
                                <StldRow>
                                    {(() => {
                                        if (isDesktop && !showTableView) {
                                            return (
                                                <StldRow>
                                                    <TableTimesheetPI listaTS={TimeSheetData}
                                                        loadingData={loadingData}
                                                        openObservacoesTimesheet={openObservacoesTimesheet}
                                                        openModalASolicitarEsclarecimento={openModalASolicitarEsclarecimento}
                                                        openModalTimesheetTimeline={openModalTimesheetTimeline}
                                                        isFromProjetoInterno={true}
                                                    ></TableTimesheetPI>
                                                </StldRow>
                                            );
                                        }
                                        else {
                                            return (
                                                <StldRow>
                                                    {TimeSheetData != null && TimeSheetData.data.itens.map((item, index) => {
                                                        return (
                                                            <StldColumn key={index} xs="12" sm="6" md="4" lg="3" xl="3">
                                                                <CardAtividadesOptions
                                                                    index={index}
                                                                    item={item}
                                                                    getCardId={getCardId}
                                                                    openObservacoesTimesheet={openObservacoesTimesheet}
                                                                    openModalASolicitarEsclarecimento={openModalASolicitarEsclarecimento}
                                                                    openModalTimesheetTimeline={openModalTimesheetTimeline}
                                                                />
                                                            </StldColumn>
                                                        )
                                                    })}
                                                </StldRow>
                                            )
                                        }
                                    })()}
                                </StldRow>
                                {(() => {
                                    if (TimeSheetData != null) {
                                        return (
                                            <PaginationCustom
                                                isMobile={isMobile}
                                                isDesktop={isDesktop}
                                                length={TimeSheetData?.data?.page?.length ?? 0}
                                                recordsTotal={TimeSheetData?.data?.page?.recordsTotal ?? 0}
                                                currentPage={currentPage ?? 0}
                                                formData={formData}
                                                pageSize={pageSize ?? 10}
                                                setPageSize={setPageSize}
                                                setPage={(page) => setCurrentPage(page)} />
                                        )
                                    }
                                    return null
                                })()}
                            </TabPanel>
                            <TabPanel>
                                {loadingData ? <StldRow>
                                    <div className="text-center">
                                        <div className="d-flex align-items-center">
                                            <strong style={{ color: "#EE4B21" }}>Atualizando...</strong>
                                            <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                        </div>
                                    </div>
                                </StldRow> : ''}
                                <StldRow>
                                    {(() => {
                                        if (isDesktop && !showTableView) {
                                            return (
                                                <StldRow>
                                                    <TableTimesheetPI listaTS={TimeSheetData}
                                                        loadingData={loadingData}
                                                        openObservacoesTimesheet={openObservacoesTimesheet}
                                                        openModalASolicitarEsclarecimento={openModalASolicitarEsclarecimento}
                                                        openModalTimesheetTimeline={openModalTimesheetTimeline}
                                                    ></TableTimesheetPI>
                                                </StldRow>
                                            );
                                        }
                                        else {
                                            return (
                                                <StldRow>
                                                    {TimeSheetData != null && TimeSheetData.data.itens.map((item, index) => {
                                                        return (
                                                            <StldColumn key={index} xs="12" sm="6" md="4" lg="3" xl="3">
                                                                <CardAtividadesOptions
                                                                    index={index}
                                                                    item={item}
                                                                    getCardId={getCardId}
                                                                    openObservacoesTimesheet={openObservacoesTimesheet}
                                                                    openModalASolicitarEsclarecimento={openModalASolicitarEsclarecimento}
                                                                    openModalTimesheetTimeline={openModalTimesheetTimeline}
                                                                />
                                                            </StldColumn>
                                                        )
                                                    })}
                                                </StldRow>
                                            )
                                        }
                                    })()}
                                </StldRow>
                                {(() => {
                                    if (TimeSheetData != null) {
                                        return (
                                            <PaginationCustom
                                                isMobile={isMobile}
                                                isDesktop={isDesktop}
                                                length={TimeSheetData?.data?.page?.length ?? 0}
                                                recordsTotal={TimeSheetData?.data?.page?.recordsTotal ?? 0}
                                                currentPage={currentPage ?? 0}
                                                formData={formData}
                                                pageSize={pageSize ?? 10}
                                                setPageSize={setPageSize}
                                                setPage={(page) => setCurrentPage(page)} />
                                        )
                                    }
                                    return null
                                })()}
                            </TabPanel>
                            <TabPanel>
                                {loadingData ? <StldRow>
                                    <div className="text-center">
                                        <div className="d-flex align-items-center">
                                            <strong style={{ color: "#EE4B21" }}>Atualizando...</strong>
                                            <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                        </div>
                                    </div>
                                </StldRow> : ''}
                                <StldRow>
                                    {(() => {
                                        if (isDesktop && !showTableView) {
                                            return (
                                                <StldRow>
                                                    <TableTimesheetPI listaTS={TimeSheetData}
                                                        loadingData={loadingData}
                                                        openObservacoesTimesheet={openObservacoesTimesheet}
                                                        openModalASolicitarEsclarecimento={openModalASolicitarEsclarecimento}
                                                        openModalTimesheetTimeline={openModalTimesheetTimeline}
                                                    ></TableTimesheetPI>
                                                </StldRow>
                                            );
                                        }
                                        else {
                                            return (
                                                <StldRow>
                                                    {TimeSheetData != null && TimeSheetData.data.itens.map((item, index) => {
                                                        return (
                                                            <StldColumn key={index} xs="12" sm="6" md="4" lg="3" xl="3">
                                                                <CardAtividadesOptions
                                                                    index={index}
                                                                    item={item}
                                                                    getCardId={getCardId}
                                                                    openObservacoesTimesheet={openObservacoesTimesheet}
                                                                    openModalASolicitarEsclarecimento={openModalASolicitarEsclarecimento}
                                                                    openModalTimesheetTimeline={openModalTimesheetTimeline}
                                                                />
                                                            </StldColumn>
                                                        )
                                                    })}
                                                </StldRow>
                                            )
                                        }
                                    })()}
                                </StldRow>
                                {(() => {
                                    if (TimeSheetData != null) {
                                        return (
                                            <PaginationCustom
                                                isMobile={isMobile}
                                                isDesktop={isDesktop}
                                                length={TimeSheetData?.data?.page?.length ?? 0}
                                                recordsTotal={TimeSheetData?.data?.page?.recordsTotal ?? 0}
                                                currentPage={currentPage ?? 0}
                                                formData={formData}
                                                pageSize={pageSize ?? 10}
                                                setPageSize={setPageSize}
                                                setPage={(page) => setCurrentPage(page)} />
                                        )
                                    }
                                    return null
                                })()}
                            </TabPanel>
                        </Tabs>
                    </div>
                    <br />
                    <ModalProjetoInterno
                        atividades={atividades}
                        isDesktop={isDesktop}
                        peritosList={peritosList}
                        isOpen={modalIsOpen}
                        formData={formData}
                        onGetPerito={onGetPerito}
                        setIsOpen={setIsOpen}
                        ariaHideApp={false}>
                    </ModalProjetoInterno>
                    <ModalObservacao
                        isOpen={modalObservacoes}
                        onAfterOpen={afterNotifyGrupoOpenModal}
                        onRequestClose={closeModalObservacoes}
                        idTimesheet={selectedIdTimesheet}
                    >
                    </ModalObservacao>
                    <ModalEsclarecimento
                        timesheet={{ timesheet: { idTimesheet: selectedIdTimesheet } }}
                        isOpen={modalEsclarecimento}
                        onRequestClose={onRemoveEsclarecimento}
                        loadPage={formData}
                        setIsOpen={() => setmodalEsclarecimento(false)}
                    >
                    </ModalEsclarecimento>
                    <ModalTimelinePI
                        isOpen={modalTimelineIsOpen}
                        setIsOpen={setmodalTimelineIsOpen}
                        onRequestClose={() => setmodalTimelineIsOpen(false)}
                        idTimesheet={selectedTimesheet?.idTimesheet}
                        timelineInfs={[
                            {
                                label: "Data do Sinistro",
                                value: selectedTimesheet?.dataSinistro || "Não informado"
                            },
                            {
                                label: "Data de abertura do Sinistro",
                                value: selectedTimesheet?.dataAbertura
                            },
                            {
                                label: "Data de abertura do TS",
                                value: selectedTimesheet?.dataTimesheet
                            }
                        ]}
                        porEtapaAprovacao={selectedTimesheet?.slaPorEtapa}
                        finalizacaoTS={selectedTimesheet?.dataFinalizacaoTS}
                        nomeEtapaAtual={selectedTimesheet?.workflow}
                    >
                    </ModalTimelinePI>
                </StyledDefaultPage>
            </main >

        </section >
    );
};

export const TimeSheetPIPage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <>
            {isMenuOpen ? (
                <MenuPage
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ) : (
                <>
                    <Header
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                    <TimeSheetPI />

                </>
            )}
        </>
    );
};